import ContentTypes from "../../../../../lib/html5-software-library/src/ranj/eng/content/ContentTypes";
import Anchor from "../../../../../lib/html5-software-library/src/ranj/layout/Anchor";
import DialogPlayerMediator from "../../../ngt/dialog/view/DialogPlayerMediator";
import KeyDecisionInteractionEvent from "../../key-decisions/event/KeyDecisionInteractionEvent";
import KeyDecisionAnswer from "../../key-decisions/model/KeyDecisionAnswer";
import DisplayObjectUtil from "../../util/DisplayObjectUtil";

export default class DialogScreenMediator extends DialogPlayerMediator {
    constructor(target, dispatcher, soundManager, assetLibrary, assetLocator, assetLoadService, scenarioLibrary,
        mediatorManager, npcModel, config, layoutManager, clickEaterFactory, languagePack, soundConfig) {

        super(target, dispatcher, soundManager, assetLibrary, assetLocator, assetLoadService, scenarioLibrary,
            mediatorManager, npcModel, config, layoutManager, clickEaterFactory, languagePack, soundConfig);

        this._assetLibrary = assetLibrary;
        this._optimalAnswers = [];
        this._playerAnswers = [];
        this._soundManager = soundManager;
        this._soundConfig = soundConfig;
    }

    initialize() {
        super.initialize();
        this.preventClickThrough();
    }

    _disableBackButton() {
        this.dispatch(KeyDecisionInteractionEvent.HIDE_ABORT_BUTTON);
    }

    _handleDialogOptionsChanged() {
        const currentOptions = this.getDialogPlayer().getCurrentOptions();
        for (let i = 0; i < currentOptions.length; i++) {
            const optionContent = currentOptions[i].getData().getData().content;
            if (optionContent.getType() == ContentTypes.TYPE_KEY_MOMENT_CHOICE) {
                // Key Moment Choice therefore no way back
                this._disableBackButton();
                if (KeyDecisionAnswer.GOOD_RATING == optionContent.getSituationDescription()) {
                    // Key Decision: In case of Good Key Moment Choice, save it into an optimal answer
                    let newKDA = new KeyDecisionAnswer(optionContent.getKeyMomentID(), optionContent.getChoice(), optionContent.getTip(), optionContent.getSituationDescription(), false);
                    if (!this._optimalAnswers.some(KDA => KDA.id === newKDA.id)) {
                        this._optimalAnswers.push(newKDA);
                    }
                }
            }
        }
        super._handleDialogOptionsChanged();
    }

    _onDialogEnd(evt) {
        // Key Decision: Add optimal answers and player answers within the content for further processing
        evt.params.contentPlayer.getContent().optimalAnswers = this._optimalAnswers;
        evt.params.contentPlayer.getContent().playerAnswers = this._playerAnswers;



        this._soundManager.stopSound(this._backgroundAudio);
        console.log("Stopped audio: " + this._backgroundAudioId);
        if(this._soundManager.isSoundPlaying(this._backgroundAudioId)) {
            let soundInstance = this._soundManager.getSoundInstance(this._backgroundAudioId);
            this._soundManager.stopSound(soundInstance);
        }
        super._onDialogEnd(evt);
    }

    _handleDialogOptionChosen(option) {
        const content = option.getData().getData().content;
        if (content.getType() == ContentTypes.TYPE_KEY_MOMENT_CHOICE) {
            // Key Decision: In case of Good Key Moment Choice, save it as player answer
            this._playerAnswers.push(new KeyDecisionAnswer(content.getKeyMomentID(), content.getChoice(), content.getTip(), content.getSituationDescription(), false));
        }

        if (content !== null && DialogPlayerMediator.USE_CHAT_HISTORY) {
            this._addToHistory(this.youID, content.getText());
        }

        super._handleDialogOptionChosen(option);
    }

    _handleImageContent(content) {
        const imageID = content.getImage();
        this._playBackgroundAudio(imageID);
        super._handleImageContent(content);
    }

    _playBackgroundAudio(imageId) {
        if(this._backgroundAudio!= null) {
            this._soundManager.stopSound(this._backgroundAudio);
            console.log("Stopped audio: " + this._backgroundAudioId);
            if(this._soundManager.isSoundPlaying(this._backgroundAudioId)) {
                let soundInstance = this._soundManager.getSoundInstance(this._backgroundAudioId);
                this._soundManager.stopSound(soundInstance);
            }
        }
        
        this._backgroundAudioId = this._soundConfig.getSoundId(imageId);
        if(!this._soundManager.isSoundPlaying(this._backgroundAudioId)) {
            this._backgroundAudio = this._soundManager.playSound(this._backgroundAudioId, null,null,0,0,-1, this._soundConfig.getVolume(this._backgroundAudioId));
        }
    }

    _handleTextContent(content) {
        super._handleTextContent(content);
    }


    _handleOverlayImageContent(content) {
        const imageId = content.getImage();
        this._changeImage(this._target.ImagePlaceholder, imageId);
        this.getDialogPlayer().contentCompleted(content);
    }

    _changeImage(imageContainer, imageId) {
        return new Promise(resolve => {
            const childrenToRemove = [...imageContainer.children]; // shallow copy as we want to remove the elements that were children at this specific moment

            const bitmap = this._assetLibrary.tryGetBitmapFromImageId(imageId);
            DisplayObjectUtil.anchorDisplayObject(bitmap, Anchor.TL);
            bitmap.alpha = 0;

            imageContainer.addChild(bitmap);

            createjs.Tween.get(bitmap)
                .to({ alpha: 1 }, 450, createjs.Ease.sineOut)
                .call(resolve);

            childrenToRemove.forEach(c => {
                createjs.Tween.get(c)
                    .wait(150)
                    .to({ alpha: 0 }, 300, createjs.Ease.sineIn)
                    .call(() => imageContainer.removeChild(c));
            });
        });
    }

}